<template>
  <div>
    <number-field label="偏移" v-model="offset" :disabled="!editable"></number-field>
    <select-field label="寄存器数量" v-model="regNum" :list="[1, 2]" :disabled="!editable"></select-field>
    <submit-field @click="submit" :disabled="!editable ">确定</submit-field>
  </div>
</template>

<script>
import NumberField from '@/components/utils/number-field'
import SelectField from '@/components/utils/select-field'
import SubmitField from '@/components/utils/submit-field'

export default {
  props: {
    defaults: {
      required: false,
      default: Object.create(null),
      type: Object
    },
    event: {
      required: false,
      default: 'plc-device-data',
      type: String
    },
    editable: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      offset: 0,
      regNum: 1
    }
  },
  components: {
    NumberField,
    SelectField,
    SubmitField
  },
  methods: {
    refresh () {
      this.offset = this.defaults.offset
      this.regNum = this.defaults.regNum
    },
    submit () {
      this.$emitter.emit(this.event, {
        _id: this.defaults._id,
        offset: this.offset,
        regNum: this.regNum
      })

      this.$emitter.once(`${this.event}Resp`, err => {
        if (!err) {
          this.editable = false
        }
      })
    }
  },
  created () {
    this.refresh()
  },
  watch: {
    defaults () {
      this.refresh()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/modbus-data-point.vue